import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
import { usePathname } from '../hooks/usePathname';
export function Navigation() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const pathname = usePathname();
  // Close the mobile menu whenever the page changes.
  useEffect(() => setIsMobileMenuOpen(false), [pathname]);
  const navLinks = [{
    name: 'My Story',
    href: '/my-story'
  }, {
    name: 'Services',
    href: '/services'
  }, {
    name: 'Results',
    href: '/results'
  }, {
    name: 'Resources',
    href: '/resources'
  }, {
    name: 'Contact',
    href: '/contact'
  }];
  const isActive = (href: string) => pathname === href || pathname.startsWith(`${href}/`);
  return <nav className="sticky top-0 z-50 w-full bg-white border-b border-gray-100" data-id="element-134" data-mp="szlge661t64x">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-135" data-mp="oz1jn3pe04jb">
        <div className="flex justify-between items-center h-20" data-id="element-136" data-mp="oworjxpx0dsj">
          {/* Logo — links to homepage */}
          <div className="flex-shrink-0 flex items-center" data-id="element-137" data-mp="di24aszraazi">
            <a href="/" aria-label="Break a Pencil — Home" data-id="element-138" data-mp="hi2hkab4cg4z">
              <img src="https://cdn.magicpatterns.com/uploads/9m9TJhXcQdRhFXjBURhPma/Pencil--jpeg.png" alt="Break a Pencil Consulting" className="h-20 w-auto object-contain" data-id="element-139" data-mp="mgnhe8mgkxsw" />
            </a>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8" data-id="element-140" data-mp="10fn77jlpjiqn">
            <div className="flex space-x-6" data-id="element-141" data-mp="10dsli32m3mli">
              {navLinks.map(link => <a key={link.name} href={link.href} className={`text-sm font-medium transition-colors border-b-2 pb-0.5 ${isActive(link.href) ? 'text-brand-orange border-brand-orange' : 'text-brand-gray-light border-transparent hover:text-brand-orange'}`} data-id="element-142" data-mp="157nb1n4wevsi">
                  {link.name}
                </a>)}
            </div>
            <a href="https://scheduler.zoom.us/breakapencil/intro-call-30" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-6 py-2.5 border border-transparent text-sm font-bold rounded bg-brand-orange text-white hover:bg-brand-orange-hover transition-colors" data-id="element-143" data-mp="udnw6irfmrat">
              Book a Call
            </a>
          </div>

          {/* Mobile menu button */}
          <div className="flex items-center md:hidden" data-id="element-144" data-mp="186vne9blpkrz">
            <button type="button" className="inline-flex items-center justify-center p-2 rounded-md text-brand-gray-light hover:text-brand-navy hover:bg-gray-100 focus:outline-none" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-expanded="false" data-id="element-145" data-mp="1n57kgh2vyvjo">
              <span className="sr-only" data-id="element-146" data-mp="3jy9dkpv00iuv">Open main menu</span>
              {isMobileMenuOpen ? <XIcon className="block h-6 w-6" aria-hidden="true" data-id="element-147" data-mp="1zg8btwghfrn9" /> : <MenuIcon className="block h-6 w-6" aria-hidden="true" data-id="element-148" data-mp="24cyosawzq74g" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile menu */}
      {isMobileMenuOpen && <div className="md:hidden bg-white border-b border-gray-100 shadow-lg absolute w-full" data-id="element-149" data-mp="1un5hhm3vse60">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3" data-id="element-150" data-mp="1gncpzokj5twz">
            {navLinks.map(link => <a key={link.name} href={link.href} className={`block px-3 py-2 rounded-md text-base font-medium transition-colors ${isActive(link.href) ? 'text-brand-orange bg-brand-orange/5' : 'text-brand-gray-light hover:text-brand-orange hover:bg-gray-50'}`} data-id="element-151" data-mp="1kqsmmkwlnu9o">
                {link.name}
              </a>)}
            <div className="pt-4 pb-2 px-3" data-id="element-152" data-mp="363lznn6tl8wk">
              <a href="https://scheduler.zoom.us/breakapencil/intro-call-30" target="_blank" rel="noopener noreferrer" className="block w-full text-center px-4 py-3 border border-transparent text-base font-bold rounded bg-brand-orange text-white hover:bg-brand-orange-hover" data-id="element-153" data-mp="3619ihc8vz2kk">
                Book a Call
              </a>
            </div>
          </div>
        </div>}
    </nav>;
}